import { connect } from 'react-redux'
import * as customerSelector from '../../state/detail/selector'
import * as selector from '../../state/file-upload/selector'
import { FILE_TYPE_CONFORMITY_DECLARATION } from '../../state/const'
import { CONFORMITY_DECLARATION_LIST_WIDGET } from '../../../process/ui-definition/process-ui'
import {ROLE_USER_ADMIN} from '../../../security/state/auth/const'
import * as authSelector from '../../../security/state/auth/selector'
import CustomerFileUpload from "../scan-file-upload/CustomerFileUpload";
import * as action from "../../state/file-upload/action";
import * as customerAction from "../../state/detail/action";


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        customer: customerSelector.selectCustomer(state),
        readOnly: !authSelector.selectHasRole(state, ROLE_USER_ADMIN),
        fetching: selector.selectIsFetching(state, FILE_TYPE_CONFORMITY_DECLARATION),
        widgetId: CONFORMITY_DECLARATION_LIST_WIDGET,
        fileType: FILE_TYPE_CONFORMITY_DECLARATION
    }
}

const mapDispatchToProps = {
    setDeleteFlag: action.setDeleteFlag,
    onUploadSuccess: customerAction.addCustomerFile,
    onFileDeleteFlagSuccess: customerAction.onFileDeleteFlagSuccess,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerFileUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/ConformityWidgetContainer.js